import WOW from "wowjs";

import "../home/components/navigation/navigation";
import "../home/index.css";
import "./index.css";

import "./components/scene-1/scene-1";
import "./components/scene-2/scene-2";
import "./components/scene-5/scene-5";
import "./components/scene-6/scene-6";
import "./components/scene-7/scene-7";
import "./components/scene-8/scene-8";
import "./components/scene-9/scene-9";
import "./components/scene-10/scene-10";

import "../analytics";

var wow = new WOW.WOW({
  boxClass: "wow", // default
  animateClass: "animated", // default
  offset: 0, // default
  mobile: true,
  live: false,
});
wow.init();
